import { useEffect } from 'react';
import { useCartStore } from '../store/cartStore';
import { useAuthStore } from '../store/authStore';
import { CartSyncItem, trackingService } from '../services/trackingService';
import { CartItem } from '../models';

const CART_SYNC_DEBOUNCE_MS = 1500;

function toSyncItems(items: CartItem[]): CartSyncItem[] {
  return items
    .filter((item) => item.variantId > 0 && item.quantity > 0)
    .map((item) => ({ productVariantId: item.variantId, quantity: item.quantity }));
}

export function useCartSync(): void {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    let lastSentSignature: string | null = null;

    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const items = toSyncItems(useCartStore.getState().items);
        const signature = JSON.stringify(items);
        if (signature === lastSentSignature) return;
        lastSentSignature = signature;
        trackingService.syncCart(items);
      }, CART_SYNC_DEBOUNCE_MS);
    };

    if (useCartStore.getState().items.length > 0) schedule();

    const unsubscribe = useCartStore.subscribe((state, previous) => {
      if (state.items !== previous.items) schedule();
    });

    return () => {
      clearTimeout(timer);
      unsubscribe();
    };
  }, [isAuthenticated]);
}
